// extracted by mini-css-extract-plugin
export default {"modal":"Popup_modal__F54FT","container":"Popup_container__sHKKU","close":"Popup_close__4vADF","open":"Popup_open__Bqm7t"};